import { render, staticRenderFns } from "./BoardViewData.vue?vue&type=template&id=67bb44f8"
import script from "./BoardViewData.vue?vue&type=script&lang=js"
export * from "./BoardViewData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports